import React,{useEffect,useState, useRef} from 'react'
import {InputText} from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import {Password} from 'primereact/password'
import './PasswordReset.css'
import ReCAPTCHA from 'react-google-recaptcha'
import {useSelector,useDispatch} from 'react-redux'
import {saveResetPassword,updateResetPasswordUserInfo } from '../../../actions'
import MaskIcon from '../../../components/MaskIcon'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Messages } from 'primereact/messages';
import { useHistory, useLocation } from 'react-router-dom';
import environment from '../../../environment';
const VerifiedSecurityQuestion = (props)=>{
    
    const [requiredRecaptcha, setRequiredRecaptcha] = useState(false)
    const [validateRecapt, setValidateRecapt] = useState(null)
    const dispatch = useDispatch()
    const userinfo = useSelector(state=>state.resetPasswordUserInfoReducers)
    const [requestingSaveResetPassword, setRequestingSaveResetPassword] = useState(false)
    const [showPasswordValidCheck,setShowPasswordValidCheck] = useState(false)
    const [showConfirmPasswordValidCheck,setShowConfirmPasswordValidCheck] = useState(false)
    const confirmpasswordRef = useRef(null)
    const passwordRef = useRef(null)
    const history = useHistory()

    const [invalid, setInvalid] = useState({
        answer: false,
        password: false,
        confirmpassword: false,
        passwordmatch: false,
        passwordpolicy: false
      })
    
      const resetValidation = (fields) => {
        var fieldsUpdate = {}
        if (typeof (fields) === 'string') {
          fieldsUpdate[`${fields}`] = false
        } else if (Array.isArray(fields)) {
          fields.forEach(item => {
            fieldsUpdate[`${item}`] = false
          })
        }
        setInvalid(Object.assign({}, invalid, fieldsUpdate))
      }

    const validateOnSubmit = () => {
        var allowSubmit = true;
        var invalidJSON = {}
        if (validateRecapt === null) {
          setRequiredRecaptcha(true)
          allowSubmit = false;
        }
        if (userinfo.data.answer === null) {
            Object.assign(invalidJSON, { answer: true })
            allowSubmit = false
          }
    

      if (userinfo.data.password === null) {
          Object.assign(invalidJSON, { password: true })
          allowSubmit = false
        }
    
        if (userinfo.data.confirmpassword === null) {
          Object.assign(invalidJSON, { confirmpassword: true })
          allowSubmit = false
        }
        if (userinfo.data.password !== null && userinfo.data.confirmpassword !== null) {
          if (userinfo.data.password !== userinfo.data.confirmpassword) {
            Object.assign(invalidJSON, { passwordmatch: true })
            allowSubmit = false
          }
        }
        if (userinfo.data.password !== null) {
          if (!validatePasswordPolicy(userinfo.data.password)) {
            allowSubmit = false
          }
        }
  
        if (allowSubmit) {
          dispatch(saveResetPassword(Object.assign({}, {}, userinfo.data)))
          setRequestingSaveResetPassword(true)
        } else {
          setInvalid(Object.assign({}, invalid, invalidJSON))
        }
       
       
        // if (allowSubmit) {
        //  // props.setActiveIndex(2)
        // } else {
        //  setInvalid(Object.assign({}, invalid, invalidJSON))
        // }
      }


      const [passwordRules, setPasswordRules] = useState({
        onelowerchar: false,
        oneupperchar: false,
        onenumber: false,
        onespecialchar: false,
        beginwithchar: false,
        min12char: false,
        mustnotcontainname: false,
        mustnotcontainid: false
      })
  
    
      const charIsLetter = (char) => {
        if (typeof char !== 'string') {
          return false;
        }
        return /^[a-zA-Z]+$/.test(char);
      }
    
      const containsSpecialChars = (str) => {
        const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`;
    
        const result = specialChars.split('').some(specialChar => {
          if (str.includes(specialChar)) {
            return true;
          }
          return false;
        });
    
        return result;
      }
    
      const validatePasswordPolicy = (current_password) => {
        var rules = {}
        setInvalid(Object.assign({}, invalid, { passwordpolicy: true, password:false }))
    
    
        rules[`mustnotcontainid`] = !(current_password.indexOf(userinfo.data.refnum) > -1)
        rules[`min12char`] = current_password.length >= 15;
        rules[`mustnotcontainname`] = (!(current_password.toLowerCase().indexOf(userinfo.data.firstName.toLowerCase()) > -1)) && (!(current_password.toLowerCase().indexOf(userinfo.data.lastName.toLowerCase()) > -1))
        rules[`beginwithchar`] = charIsLetter(current_password.substr(0, 1))
        rules[`onespecialchar`] = containsSpecialChars(current_password)
    
        /* eslint-disable-next-line */
        let numberCheck = /\d/
        rules[`onenumber`] = numberCheck.test(current_password)
        /* eslint-disable-next-line */
        let upperCheck = /[A-Z]/
        rules[`oneupperchar`] = upperCheck.test(current_password)
        /* eslint-disable-next-line */
        let lowerCheck = /[a-z]/
        rules[`onelowerchar`] = lowerCheck.test(current_password)
    
        var allowSubmit = true
        Object.keys(rules).forEach(item => {
          if (rules[`${item}`] === false) {
            allowSubmit = false
          }
        })
        setPasswordRules(Object.assign({}, passwordRules, rules))
        return allowSubmit
      }
      // const validateOnSubmit = () => {
      //   var allowSubmit = true;
      //   var invalidJSON = {}
    
      //   if (userinfo.data.password === null) {
      //     Object.assign(invalidJSON, { password: true })
      //     allowSubmit = false
      //   }
    
      //   if (userinfo.data.confirmpassword === null) {
      //     Object.assign(invalidJSON, { confirmpassword: true })
      //     allowSubmit = false
      //   }
      //   if (userinfo.data.password !== null && userinfo.data.confirmpassword !== null) {
      //     if (userinfo.data.password !== userinfo.data.confirmpassword) {
      //       Object.assign(invalidJSON, { passwordmatch: true })
      //       allowSubmit = false
      //     }
      //   }
      //   if (userinfo.data.password !== null) {
      //     if (!validatePasswordPolicy(userinfo.data.password)) {
      //       allowSubmit = false
      //     }
      //   }
    
    
      //   if (allowSubmit) {
      //     dispatch(saveResetPassword(Object.assign({}, {}, userinfo.data)))
      //     setRequestingSaveResetPassword(true)
      //   } else {
      //     setInvalid(Object.assign({}, invalid, invalidJSON))
      //   }
      // }
    
      const parseCookie = str =>
        str
          .split(';')
          .map(v => v.split('='))
          .reduce((acc, v) => {
            acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
            return acc;
          }, {});
          
      const [backurl, setBackUrl] = useState(null)
      useEffect(() => {
    
            // const queryParams = new URLSearchParams(window.location.search)
            // const backbtnurl = queryParams.get("backbtnurl")
            // const loginparam = queryParams.get("login")
            // if (backbtnurl !== null && backbtnurl !== '') { 
            //   setBackUrl(`${backbtnurl.replace('/login.html','')}/oauth2/authorization/oracle`)
            // }
            const url = parseCookie(document.cookie)?.from_app_url;
            setBackUrl(url)
    
      }, [])
      const initialState = { question: null, answer: null, password:null, confirmpassword:null,refnum:null }
      const isFirstRender = useRef(true)
      useEffect(() => {
        if (isFirstRender.current) {
          isFirstRender.current = false
          return
        }
        if (requestingSaveResetPassword && userinfo.requesting_save_successful) {
            setRequestingSaveResetPassword(false)
            history.push({
              pathname: '/unauth/update-success',
              state: {
                title:"Password Reset",
                message:"Your new password has been updated.",
                redirecturl: backurl!==null ? backurl  : null
              },
            });
            // if(backurl!==null){
            //     window.location.href = backurl
            // }else{
            //     window.location.href = props.defaultLoginURL
            // }
        }
        if (requestingSaveResetPassword && userinfo.message !== null) {
          if (userinfo.infoError !== null) {
            messages.current.show({ severity: 'error', summary: "", detail: userinfo.message, sticky: true });
          } else if (userinfo.message !== null) {
            props.toast.current.show({ severity: 'error', summary: "Save ResetPassword API", detail: userinfo.message, sticky: true });
          }
          setRequestingSaveResetPassword(false)
        }
    
      })
    
      const updatePasswordValidCheck = (password)=>{
    
        if(password!==null){
            if(validatePasswordPolicy(password)){
              setShowPasswordValidCheck(true)
            }else{
              setShowPasswordValidCheck(false)
            }
        }else{
          setShowPasswordValidCheck(false)
        }
      }
      const updateConfirmPasswordValidCheck = (localpassword,confirmpassword)=>{
        if (localpassword !== null && confirmpassword !== null) {
          if (localpassword === confirmpassword) {
              setShowConfirmPasswordValidCheck(true)
              resetValidation(['confirmpassword', 'passwordmatch'])
          }else{
            setShowConfirmPasswordValidCheck(false)
          }
        }else{
          setShowConfirmPasswordValidCheck(false)
        }
      }
    
      const messages = useRef(null)
      useEffect(() => {
      }, [])

    return <div>
        <div className="reference-input-message">Answer security question to proceed.</div>
        <Messages ref={messages}></Messages>
        <div className="password-input-container">
        <div className="resetpassword-question-container"><Dropdown disabled={true} value={userinfo.data.question} options={userinfo.data.questions} /></div>
        <div className="choose-another-question-link" onClick={()=>{
            var index = (userinfo.data.challengeQuestions.indexOf(userinfo.data.question)>-1) ? 
            (userinfo.data.challengeQuestions.indexOf(userinfo.data.question)+1) % 3 : 0
            dispatch(updateResetPasswordUserInfo(Object.assign({},userinfo.data,{question:userinfo.data.challengeQuestions[index]})))
        }}>Choose another question</div>

        <div className="security-answer-container"><InputText placeholder='Answer' value={userinfo.data.answer||''} onChange={(e)=>{
            resetValidation('answer')
            dispatch(updateResetPasswordUserInfo(Object.assign({}, userinfo.data, { answer: e.target.value !== '' ? e.target.value : null })))
        }}/></div>
        <div className="answer-not-sensitive">Answers are not case sensitive</div>

        {invalid.answer ? <small> <div className="p-error top-margin">Answer to question is required</div></small> : null}

          {/* Password inputs */}
          <div>
            <div className="label">Password</div>
            <div className="password-input">

              <Password placeholder="Enter password" ref={passwordRef} icon={<MaskIcon passwordRef={passwordRef} />} value={userinfo.data.password || ''} onChange={(e) => {
                if (e.target.value !== '') {
                  //constantly checking policy
                  validatePasswordPolicy(e.target.value)
                } else {
                  resetValidation(['password', 'passwordpolicy'])
                }
                updatePasswordValidCheck(e.target.value)
                updateConfirmPasswordValidCheck(e.target.value,userinfo.data.confirmpassword)
                dispatch(updateResetPasswordUserInfo(Object.assign({}, userinfo.data, { password: e.target.value !== '' ? e.target.value : null })))      
              }} toggleMask feedback={false} />
             {showPasswordValidCheck ? <div className="success-check-mark"><div className="checked-container"><FontAwesomeIcon icon={faCheck} size={"sm"} color="white" /></div></div>: null}




            </div>
            {invalid.password ? <small> <div className="p-error top-margin">Password is required</div></small> : null}
            {invalid.passwordpolicy&&userinfo.data.password!==null ? <div className="policy-container">
              <div className="left-password-policy">
                <ul>
                <div className={`${passwordRules.onelowerchar ? 'check' : 'uncheck'}`}><li>One lower case character</li></div>
                <div className={`${passwordRules.oneupperchar ? 'check' : 'uncheck'}`}><li>One upper case character</li></div>
                <div className={`${passwordRules.onenumber ? 'check' : 'uncheck'}`}><li>One number</li></div>
                <div className={`${passwordRules.onespecialchar ? 'check' : 'uncheck'}`}><li>One special character</li></div>
                </ul>
              </div>
              <div className="right-password-policy">
                <ul>
                <div className={`${passwordRules.beginwithchar ? 'check' : 'uncheck'}`}><li>Begins with a character</li></div>
                <div className={`${passwordRules.min12char ? 'check' : 'uncheck'}`}><li>15 characters minimium</li></div>
                <div className={`${passwordRules.mustnotcontainname ? 'check' : 'uncheck'}`}><li>Must not contain name</li></div>
                <div className={`${passwordRules.mustnotcontainid ? 'check' : 'uncheck'}`}><li>Must not contain ID</li></div>
                </ul>
              </div>
            </div> : null}

          </div>
          <div>
            <div className="label">Confirm Password</div>
            <div>
              <div className="password-input">
                <Password placeholder="Enter confirm password" ref={confirmpasswordRef} icon={<MaskIcon passwordRef={confirmpasswordRef} />} toggleMask feedback={false} value={userinfo.data.confirmpassword || ''} onChange={(e) => {
                  resetValidation(['confirmpassword', 'passwordmatch'])
                  updateConfirmPasswordValidCheck(userinfo.data.password,e.target.value)
                  dispatch(updateResetPasswordUserInfo(Object.assign({}, userinfo.data, { confirmpassword: e.target.value !== '' ? e.target.value : null })))
                }} />
                {showConfirmPasswordValidCheck ? <div className="success-check-mark"><div className="checked-container"><FontAwesomeIcon icon={faCheck} size={"sm"} color="white" /></div></div>: null}
              </div>
              {invalid.confirmpassword ? <small> <div className="p-error top-margin">Confirm Password is required</div></small> : null}

              {invalid.passwordmatch ? <small> <div className="p-error top-margin">Passwords must match</div></small> : null}

            </div>
          </div>
          {/* Password inputs end */}
        <div className="recapt">

            <ReCAPTCHA
            sitekey={environment.google_site_key}
            onChange={(value) => {
                if (value) {
                setValidateRecapt(value)
                setRequiredRecaptcha(false)
                }
            }}
            />

            {requiredRecaptcha ? <small><div className="error p-error">Recaptcha is required</div></small> : <div className="error-placeholder">&nbsp;&nbsp;</div>}

        </div>
        <div className="continue-btn"><Button disabled={requestingSaveResetPassword} onClick={()=>{
          if(requestingSaveResetPassword){
            return
          }
          validateOnSubmit()
        }}>{requestingSaveResetPassword ? <i className="pi pi-spin pi-spinner"></i>:<span>&nbsp;&nbsp;</span>}&nbsp;Save Changes</Button></div>
        </div>
        <div className="pre-password-message" style={{fontSize:"13px"}}>
            <strong>Note:</strong> Passwords cannot be changed more than once per day and must not be one of the last 12 passwords used.
          </div>
          <div style={{paddingTop:"8px",paddingBottom:"8px",fontSize:"13px"}}>
            <strong>HRIS Single Sign On Users:</strong> If you access the HRIS SSO applications powered by <strong>Java</strong>, do not use the following special characters in your password: 
            <span style={{color:'red'}}>@%()&amp;-~` \</span>
          </div>
        <div className="row-btn reset-password-back">
            <span className="row-btn-link" onClick={()=>{
                 props.setActiveIndex(0)
            }}>Back</span>
        </div> 
    
        {/* <div className="row-btn">
          <span className="row-btn-link">Need help? Check out our FAQs</span>
        </div> */}
    </div>
}

export default VerifiedSecurityQuestion